import type {
  IUserRepository,
  UserCreateInput,
  UserUpdateInput,
} from '../repositories/IUserRepository.js';
import type { UserEntity } from '../entities/UserEntity.js';

export type UpsertUserInput = UserCreateInput & UserUpdateInput & { ignoreDuplicates?: boolean };

interface Dependencies {
  userRepository: IUserRepository;
}

export function createUpsertUserUseCase({ userRepository }: Dependencies) {
  return async function upsertUser(input: UpsertUserInput): Promise<UserEntity> {
    return userRepository.upsert(input, input.ignoreDuplicates);
  };
}

